import CalculatorSVG from '../../assets/svg/calculator.svg';
export default CalculatorSVG;
